import React from "react";
import "./EditProductivity.css";

const EditProductivity = ({ productivitys, onChange, onSubmit }) => {
  return (
    <div className="productivity-page">
      <h1 className="productivity-title">
        Productivity
      </h1>

      <div className="productivity-container">
        <div className="productivity-table-wrapper">
          <table className="productivity-table">
            <thead>
              <tr>
                <th>
                  Departments
                </th>

                <th colSpan="2">
                  Users
                </th>
              </tr>

              <tr>
                <th></th>

                <th>
                  Hira KH
                </th>

                <th></th>
              </tr>
            </thead>

            <tbody>
              {[
                "All Departments",
                "CROWN AND BRIDGE",
                "PROSTHETICS",
                "ORTHODONTIC",
                "IMPLANTS",
                "COBALT CHROME",
                "VALPLAST",
                "PLASTER ROOM",
                "ALL DEPARTMENTS",
                "No Department",
              ].map((department, index) => (
                <tr
                  key={index}
                  className={
                    index % 2 === 0
                      ? "productivity-row-even"
                      : "productivity-row-odd"
                  }
                >
                  <td>
                    {department}
                  </td>

                  <td>
                    Scan
                  </td>

                  <td>
                    Be Assigned
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default EditProductivity;